import { render, staticRenderFns } from "./HolidaysModal.vue?vue&type=template&id=0e7f960e&scoped=true&"
import script from "./HolidaysModal.vue?vue&type=script&lang=js&"
export * from "./HolidaysModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7f960e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e7f960e')) {
      api.createRecord('0e7f960e', component.options)
    } else {
      api.reload('0e7f960e', component.options)
    }
    module.hot.accept("./HolidaysModal.vue?vue&type=template&id=0e7f960e&scoped=true&", function () {
      api.rerender('0e7f960e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modals/HolidaysModal.vue"
export default component.exports